import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import osirisLogo from 'assets/img/logos/osiris.png';
import pyramidLogo from 'assets/img/logos/pyramid.png';
import horusLogo from 'assets/img/logos/horus.png';


const Logo = ({ at = 'auth', width = 39, className, textClass, name, ...rest }) =>
{

  // Function to determine which logo image to display based on the 'name' prop
  const getLogoImage = () =>
  {
    switch (name)
    {
      case 'Osiris':
        return osirisLogo;  // If the name is 'Osiris', use the Osiris logo
      case 'Pyramid':
        return pyramidLogo;  // If the name is 'Pyramid', use the Pyramid logo
      case 'Horus':
        return horusLogo;  // If the name is 'Horus', use the Horus logo
      case 'CustomApp':
        return 'assets/img/illustrations/custom-logo.png';  // If the name is 'CustomApp', use the custom logo
      default:
        return '';  // If the name doesn't match any case, use the default image provided
    }
  };

  return (
    <span
      // Dynamically apply class names based on the 'at' prop to style the logo container
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        // Dynamically apply class names for the div that contains the logo and name
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-4 mb-4': at === 'auth'
          },
          className
        )}
      >

        {/* Display the logo image based on the name */}
        <img className="me-2" src={getLogoImage()} alt="Logo" width={width} />

        {/* Display the name of the logo with the applied styles */}
        <span className={classNames(
          'font-sans-serif', 
          textClass, 
          name === 'Horus' ? 'text-horus' : 'text-primary'
        )}>
          {name}
        </span>
      </div>
    </span>
  );
};

// Prop validation for the Logo component
Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']), // 'at' determines where the logo is displayed
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string,
  name: PropTypes.oneOf(['Pyramid', 'Osiris', 'Horus']),
};

// Export the Logo component
export default Logo;
